import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  styled,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { faqs } from "./BizdevInternshipData";

const BizdevFaq = () => {
  const [expanded, setExpanded] = useState<string | false>(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Container>
      <Header>Frequently Asked Questions (FAQ)</Header>
      <Wrapper>
        {faqs.map((faq) => (
          <Box key={faq.id} mb={2}>
            <Accordion
              sx={{
                padding: isMobile ? "6px 2px" : "12px 8px",
                background: "#19191B",
                color: "#fefefe",
                borderRadius: "12px !important",
              }}
              expanded={expanded === faq.id}
              onChange={handleChange(faq.id)}
            >
              <AccordionSummary
                expandIcon={
                  expanded === faq.id ? (
                    <CloseIcon
                      sx={{
                        fontSize: 20,
                        color: "#888888",
                        height: "32px",
                        width: "32px",
                      }}
                    />
                  ) : (
                    <AddIcon
                      sx={{
                        fontSize: 20,
                        color: "#888888",
                        height: "32px",
                        width: "32px",
                      }}
                    />
                  )
                }
              >
                <Typography
                  sx={{
                    fontSize: isMobile ? "16px" : "20px",
                    fontWeight: 700,
                    lineHeight: isMobile ? "26px" : "32px",
                  }}
                >
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  sx={{
                    fontSize: isMobile ? "14px" : "16px",
                    fontWeight: 400,
                    lineHeight: isMobile ? "22px" : "24px",
                    color: "#CFCFCF",
                  }}
                >
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Box>
        ))}
      </Wrapper>
    </Container>
  );
};

export default BizdevFaq;

// Styled Components
const Container = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "800px",
  margin: "0 auto",
  [theme.breakpoints.down(720)]: {
    width: "100%",
  },
}));

const Header = styled(Box)(({ theme }) => ({
  color: "#fefefe",
  fontSize: "48px",
  textAlign: "center",
  fontWeight: 700,
  marginBottom: "40px",

  [theme.breakpoints.down(700)]: {
    fontSize: "24px",
    lineHeight: "34px",
  },
}));

const Wrapper = styled(Box)(({ theme }) => ({
  width: "100%",
}));
